export default "__VITE_ASSET__DOvdIHT1__"